import React from 'react';
import { CouponToggleProps } from '../../types';
import './CouponToggle.css';

const CouponToggle: React.FC<CouponToggleProps> = ({
  isEnabled,
  onToggle,
  loading = false,
  className = ''
}) => {
  const handleToggle = () => {
    if (!loading) {
      onToggle(!isEnabled);
    }
  };

  return (
    <div className={`coupon-toggle ${className}`}>
      <div className="coupon-toggle__content">
        <div className="coupon-toggle__info">
          <h3 className="coupon-toggle__title">Coupon System</h3>
          <p className="coupon-toggle__description">
            Enable or disable the coupon system for your store. When enabled, customers can apply coupon codes during checkout.
          </p>
        </div>
        
        <div className="coupon-toggle__control">
          <button
            type="button"
            className={`coupon-toggle__switch ${isEnabled ? 'active' : ''} ${loading ? 'loading' : ''}`}
            onClick={handleToggle}
            disabled={loading}
            aria-label={`${isEnabled ? 'Disable' : 'Enable'} coupon system`}
          >
            <div className="coupon-toggle__track">
              <div className="coupon-toggle__thumb">
                {loading && (
                  <div className="coupon-toggle__spinner">
                    <div className="coupon-toggle__spinner-circle"></div>
                  </div>
                )}
              </div>
            </div>
          </button>
          
          <div className="coupon-toggle__status">
            <span className={`coupon-toggle__status-text ${isEnabled ? 'enabled' : 'disabled'}`}>
              {loading ? 'Updating...' : (isEnabled ? 'Enabled' : 'Disabled')}
            </span>
          </div>
        </div>
      </div>
      
      {isEnabled && (
        <div className="coupon-toggle__enabled-info">
          <div className="coupon-toggle__enabled-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="coupon-toggle__enabled-content">
            <h4 className="coupon-toggle__enabled-title">Coupon System Active</h4>
            <p className="coupon-toggle__enabled-description">
              Customers can now apply coupon codes during checkout. You can manage coupons in the Coupons section.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponToggle;
